import { CommonModule } from '@angular/common';
import { Component, effect, input, OnInit } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-validated-date-picker',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslatePipe],
  templateUrl: './validated-date-picker.component.html',
  styleUrl: './validated-date-picker.component.scss',
})
export class ValidatedDatePickerComponent implements OnInit {
  label = input.required<string>();
  inputFormControlName = input.required<string>();
  inputFormControl = input.required<FormControl<Date | string | null>>();
  validationTrainslations = input<{ [key: string]: string }>();
  leaveSpaceForValidation = input<boolean>(false);
  disabled = input<boolean>(false);

  private syncDisabled = effect(() => {
    const ctrl = this.inputFormControl();
    if (this.disabled()) {
      ctrl.disable({ emitEvent: false });
    }
  });

  ngOnInit(): void {
    this.inputFormControl().valueChanges.subscribe((currentValue) => {
      this.handleValueChange(currentValue);
    });

    this.handleValueChange(this.inputFormControl().value);
  }

  private handleValueChange(currentValue: string | Date | null) {
    let formattedDate: string | null = null;
    const control = this.inputFormControl();

    if (currentValue instanceof Date) {
      formattedDate = currentValue.toISOString().split('T')[0];
    } else if (typeof currentValue === 'string' && currentValue.includes('T')) {
      formattedDate = currentValue.split('T')[0];
    }

    if (formattedDate !== null && formattedDate !== currentValue) {
      control.patchValue(formattedDate, { emitEvent: false });
    }
  }

  hasRequiredValidator(): boolean {
    return this.inputFormControl().hasValidator(Validators.required);
  }

  errorKeys(): string[] {
    const control = this.inputFormControl();
    return control.errors ? Object.keys(control.errors) : [];
  }

  getErrorMessage(errorKey: string): string {
    return this.validationTrainslations()?.[errorKey] ?? errorKey;
  }
}
